import AITrainerMain from "@/features/aiTrainer/components/AITrainerMain";
import React from "react";

const AiTrainer = () => {
  return <AITrainerMain />;
};

export default AiTrainer;
